import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Help from "../components/Help";
import Login from "../components/Login";
import Products from "../components/Products";
import SearchProducts from "../components/SearchProducts";
import ProductDetails from "../components/SearchProducts/ProductDetails";
import Search from "../components/SearchProducts/Search";
import Upload from "../components/Upload";
import AuthLayout from "../layouts/AuthLayout";
import { NoAuthLayout } from "../layouts/NoAuth";
import { ROUTES } from "./constants";

const Home = React.lazy(() => import("../components/Home"));

export const AppRoutes = () => {
  return (
    <Routes>
      <Route
        path={ROUTES.LOGIN}
        element={
          <NoAuthLayout>
            <Login />
          </NoAuthLayout>
        }
      />
      <Route
        path={ROUTES.HOME}
        element={
          <AuthLayout>
            <Home />
          </AuthLayout>
        }
      >
        <Route
          path={ROUTES.UPLOAD}
          element={
            <AuthLayout>
              <Upload />
            </AuthLayout>
          }
        />
        <Route
          path={ROUTES.PRODUCTS}
          element={
            <AuthLayout>
              <Products />
            </AuthLayout>
          }
        />
        <Route
          path={ROUTES.SMARTSEARCH}
          element={
            <AuthLayout>
              <SearchProducts />
            </AuthLayout>
          }
        />
        <Route
          path={ROUTES.SEARCH}
          element={
            <AuthLayout>
              <Search />
            </AuthLayout>
          }
        />
        <Route
          path={ROUTES.PRODUCTDETAILS}
          element={
            <AuthLayout>
              <ProductDetails />
            </AuthLayout>
          }
        />
        <Route
          path={ROUTES.HELP}
          element={
            <AuthLayout>
              <Help />
            </AuthLayout>
          }
        />
        <Route path="*" element={<Navigate to={ROUTES.UPLOAD} replace />} />
      </Route>
    </Routes>
  );
};
